module.exports = __webpack_public_path__ + "img/b6.e7abc43d.png";